document.addEventListener('DOMContentLoaded', function (event) {
  let iframes = document.querySelectorAll('.iFrame');
  if (iframes) {
    iframes.forEach(function (iframe) {
      setTimeout(() => {
        let parentSection = iframe.closest('.Section');
        let style = getComputedStyle(parentSection);
        let sectionBackground = style.backgroundColor;
        let element = iframe.contentWindow || iframe.contentDocument;
        if (element.document) element = element.document;
        element.body.style.backgroundColor = sectionBackground;
      }, 1000);
    });
  }
});
